import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import Cover from '../components/cover/cover'
import Layout from "../components/layout"
import SEO from "../components/seo"
import TeamTile from '../components/team-tile/team-tile'

import VolunteerForm from "../components/form/volunteer"
import OrganisationForm from "../components/form/organisations"

import cover from "../images/donate-cover.jpg"
import { StaticImage } from "gatsby-plugin-image"

const CollaboratePage = () => {

    const [activeTab, setActiveTab] = useState('volunteers');

    const data = useStaticQuery(graphql`
    query {
        allContentfulTeam {
            nodes {
              about {
                about
              }
              image {
                file {
                  url
                }
              }
              id
              name
              role
            }
          }
        }
    `)
    
    return (
  <Layout>
    <SEO title="We Clothe Them - Collaborate" />
    <Cover image={cover} title={`Collaborate`} />
    <section className={`sm`}>
      <div className={`content-sm`}>
        <h2>Collaborate with us</h2>
        <p className={`margin-bottom`}>Partner with us to complement our expertise and capabilities and achieve the common goal of helping those in need! WCT welcomes you to collaborate and be a part of our mission to provide the joy of warmth of clothing to those in need.</p>
        <hr className={`margins`} />
        <div className={`toggle margin-bottom`}>
            <div className={`option ${activeTab === 'volunteers' ? 'active' : null}`} onClick={()=>{
                setActiveTab('volunteers')
            }}>For Volunteers</div>
            <div className={`option ${activeTab === 'organisations' ? 'active' : null}`} onClick={()=>{
                setActiveTab('organisations')
            }}>For Organisations</div>
        </div>        
        {activeTab === 'volunteers' && <div className={`margins-v`}>
            <h6 className={`letter-spaced-heading`}>Volunteering</h6>
            <h2 className={`margin-bottom`}>Join the initiative</h2>
            <div className={`margins-v`}>
                <VolunteerForm />
            </div>
        </div>}
        {activeTab === 'organisations' && <div className={`margins-v`}>
            <h6 className={`letter-spaced-heading`}>Organisations & Corporates</h6>
            <h2 className={`margin-bottom`}>Start a collection drive</h2>
            <div className={`margins-v`}>
                <OrganisationForm />
            </div>
        </div>}
      </div>
    </section>
  </Layout>
    )
}

export default CollaboratePage